import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { store, persistor } from './store/store'
import { AuthProvider } from './contexts/AuthContext'
import { InflationProvider } from './contexts/InflationContext'
import { DataPersistenceProvider } from './contexts/DataPersistenceContext'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AuthProvider>
            <InflationProvider>
              <DataPersistenceProvider>
                <HelmetProvider>
                  <App />
                </HelmetProvider>
              </DataPersistenceProvider>
            </InflationProvider>
          </AuthProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>,
)
